/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import { InputV2, DialogDefaultV2, TrueFalseSelectV2 } from '../../../../components/v2';
import { v4 as uuidv4 } from 'uuid';

const schema = {
  tamanho: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  ativo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const ProdutoTamanhoFormulario = ({ selectedTamanho, open, onClose, onSave }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setValues({
        ativo: true,
      });
    } else {
      setValues({});
    }
  }, [open]);

  useEffect(() => {
    if (selectedTamanho) {
      setValues(selectedTamanho);
    } else {
      setValues({
        ativo: true,
      });
    }
  }, [selectedTamanho]);

  const onSaveLocal = () => {
    const erros = validate(values, schema);
    setErrors(erros);
    if (!erros) {
      onSave({
        ...values,
        id: values.id || uuidv4(),
      });
      setErrors({});
      setValues({});
    }
  };

  const onCloseLocal = () => {
    setErrors({});
    setValues({});
    onClose();
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSaveLocal}
      title="Tamanho do Produto"
      confirmMessage="Salvar"
      maxWidth="md"
    >
      <Grid container spacing={3}>
        <Grid size={{ xs: 8 }}>
          <InputV2
            label="Tamanho"
            name="tamanho"
            onChange={handleChange}
            value={values.tamanho}
            isRequired
            error={!!(errors && errors.tamanho)}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <TrueFalseSelectV2
            error={!!(errors && errors.ativo)}
            isRequired
            label="Ativo"
            name="ativo"
            onChange={handleChange}
            value={values.ativo}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

export default ProdutoTamanhoFormulario;
